import { isPresent } from "neetocist";
import { withT } from "neetocommons/react-utils";
import { Download } from "neetoicons";
import { Button } from "neetoui";

const DownloadButton = withT(
  ({
    t,
    count,
    onClick,
    "data-testid": dataTestid = "download-button",
    tooltipProps,
  }) => (
    <div className="neeto-molecules-subheader__download">
      <Button
        {...{ onClick }}
        data-testid={isPresent(dataTestid) ? dataTestid : "download-button"}
        icon={Download}
        style="text"
        tooltipProps={{
          content: t("neetoMolecules.common.download"),
          position: "bottom",
          touch: ["hold", 500],
          ...tooltipProps,
        }}
      />
      {count && (
        <span className="neeto-molecules-subheader__download-count">
          {count}
        </span>
      )}
    </div>
  )
);

export default DownloadButton;
